import {
  Flex,
  Menu,
  MenuButton,
  MenuList,
  Text,
  Button,
  Box,
} from "@chakra-ui/react"

import { useAppSelector } from "app/hooks"
import { camelCaseToDisplayText } from "components/add-tag-modal/AddTagModal"
import RoundedBadge from "components/table/rounded-badge"
import { selectCompanyTags } from "store/auth/authSlice"

const ViewTagMenu = () => {
  const companyTagData = useAppSelector(selectCompanyTags)
  return (
    <Menu autoSelect={false}>
      <MenuButton
        px='12px'
        h='30px'
        variant='secondary'
        as={Button}
        colorScheme='black'
        role='group'
        _focus={{}}
        _active={{}}
      >
        <Flex justifyContent='space-between' alignItems='center'>
          <Text
            fontWeight='500'
            fontSize='14px'
            lineHeight='10px'
            color='#006F80'
            _groupHover={{ color: "#fff" }}
          >
            View Tag
          </Text>
        </Flex>
      </MenuButton>

      <MenuList minWidth='200px' zIndex={2}>
        {companyTagData ? (
          Object.entries(companyTagData || {}).map(([key, value]) => {
            if (!value) return null

            const label =
              typeof value === "string"
                ? `${camelCaseToDisplayText(key) || key}: ${value as string}`
                : camelCaseToDisplayText(key) || key

            return (
              <Box
                key={key}
                display='block'
                marginBottom={{ base: "3px", md: "10px" }}
              >
                <RoundedBadge marginRight='0px' text={label} />
              </Box>
            )
          })
        ) : (
          <Box fontWeight={600} textAlign='center'>
            No Tag List
          </Box>
        )}
      </MenuList>
    </Menu>
  )
}

export default ViewTagMenu
